import axios from "axios";
import { UploadPrestadorSempre } from "../models/upload-prestador-sempre";

export const PRESTADOR_URL = `PrestadorSempre`;

export const prestadorSempreServices = {
  getById: (id: string) => {
    return axios.get<any>(`${PRESTADOR_URL}/${id}`);
  },
  lookup: (queryParams: any) => {
    return axios.get<any>(`${PRESTADOR_URL}/Lookup`, {
      params: {
        ...queryParams,
      },
    });
  },
  importar: function (formData: FormData) {
    return axios.post<UploadPrestadorSempre>(`${PRESTADOR_URL}/upload-file`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      onUploadProgress: (progressEvent) => {
        const percentCompleted = Math.round((progressEvent.loaded * 100) / (progressEvent.total || 1));
        return percentCompleted;
      },
    });
  },
  descargarPlantilla: function () {
    return axios.get(`${PRESTADOR_URL}/plantilla`, {
      responseType: 'blob',
    });
  },
};
